<template>
    <div class="sharing-actions">
        <div v-if="showCopiedToClipboard" class="sharing-actions__copy-success ui-center-content">
            <Icon class="green" :size="16">
                <IconCheck />
            </Icon>
            <div class="copy-light-small">Link erfolgreich kopiert</div>
        </div>
        <div v-else class="action-list">
            <div class="action-list__item ui-center-vertically" v-for="action in actions" :key="action.event" @click="actionClickHandler(action.event)">
                <icon class="action-list__item__icon"><component :is="action.icon" /></icon>
                <span class="action-list__item__label copy black">{{ action.label }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Icon from '@/components/Icon.vue'
import IconCopy from '@/components/icons/IconCopy.vue'
import IconEmail from '@/components/icons/IconEmail.vue'
import IconCheck from '@/components/icons/IconCheck.vue'
import * as api from '@/api';
import eventBus from '@/utils/event-bus';

export default {
    components: {
        Icon,
        IconCopy,
        IconEmail,
        IconCheck,
    },
    data() {
        return {
            showCopiedToClipboard: false,
        }
    },
    computed: {
        ...mapGetters(['mobile', 'isMAPage']),
        actions() {
            const items = [
                {
                    event: 'copyLink',
                    icon: 'IconCopy',
                    label: 'Link kopieren'
                },
            ]
            items.push({
                event: 'shareEmail',
                icon: 'IconEmail',
                label: 'Route per Mail teilen'
            })

            return items
        }
    },
    watch: {
        showCopiedToClipboard(newVal) {
            this.$emit('copiedChange', newVal)
        }
    },
    methods: {
        actionClickHandler(action) {
            if(action === 'copyLink') {
                this.copyLinkToClipboard()
            } else if(action === 'shareEmail') {
                if(this.isMAPage) {
                    eventBus.$emit('showEmailSharingForm', this.getPageUrl())
                    this.$emit('closePopup')
                } else {
                    this.openEmailClient()
                }
            }
        },
        getPageUrl() {
            if(this.isMAPage) {
                const fullLink = window.location.href
                return fullLink.replace(window.location.host, 'www.oeamtc.at')
            }
            return window.location.href
        },
        async copyLinkToClipboard() {
            const shortUrl  = await api.shortlinks.shortenURL(this.getPageUrl())
            try {
                await navigator.clipboard.writeText(shortUrl.data.shortUrl);
                this.showCopiedToClipboard = true

                setTimeout(() => {
                    this.$emit('closePopup')
                    setTimeout(() => {
                        this.showCopiedToClipboard = false
                    }, 300);
                }, 3000);
            } catch (err) {
                console.error('Failed to copy: ', err);
            }
        },
        async openEmailClient() {
            const shortUrl  = await api.shortlinks.shortenURL(this.getPageUrl())
            const emailParams = `?subject=%C3%96AMTC%20Routenempfehlung&body=Sehr%20geehrtes%20Mitglied%2C%0A%0Aunter%20folgendem%20Link%20finden%20Sie%20die%20%C3%96AMTC%20Routenempfehlung%20f%C3%BCr%20Ihre%20Route%3A%20${shortUrl.data.shortUrl}.%0A%0AMit%20freundlichen%20Gr%C3%BC%C3%9Fen%0A%0AIhr%20%C3%96AMTC`
            window.location.href = 'mailto:' + emailParams
            this.$emit('closePopup')
        }
    }
}
</script>

<style lang="scss" scoped>
.sharing-actions {
    &__copy-success {
        gap: 4px;
        margin: 4px -8px 3px;
    }
}
</style>